export const isLumin = name =>
  name
    ? name.trim().toLowerCase().includes('luminaris 200') ||
    name.trim().toLowerCase().includes('vividrip')
    : false;
